import { transportOrderSlice } from "./transportorder.slice"
import { uiSlice } from "./ui.slice"
import { combineReducers } from "redux"
import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { notificationSettingsApi } from "../client/notification-settings/notificationSettingsApi"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { loginSlice } from "../configuration/login/login.slice"
import { tokenSlice } from "../configuration/token/token.slice"
import { transportOrderHubApi } from "../client/transportorder-hub/transportOrderHubApi"
import { transportationReportApi as transportationReportApi } from "@/client/transportation-report/transportationReportApi"
import { freightForwarderInfoApi } from "../client/freight-forwarder-info/freightForwarderInfoApi"
import { asnMatchingApi } from "../client/asn-matching/asnMatchingApi"
import { mfhApi } from "../client/mfh/mfhApi"
import { agreementApi } from "../client/agreement/agreeementApi"
import { transportationReportSlice } from "@/redux/transportation-report.slice"
import { adminUiSlice } from "@/redux/admin-ui.slice"

export const reducers = combineReducers({
    [loginSlice.reducerPath]: loginSlice.reducer,
    [tokenSlice.reducerPath]: tokenSlice.reducer,
    [transportOrderSlice.reducerPath]: transportOrderSlice.reducer,
    [transportOrderHubApi.reducerPath]: transportOrderHubApi.reducer,
    [notificationSettingsApi.reducerPath]: notificationSettingsApi.reducer,
    [transportationReportSlice.reducerPath]: transportationReportSlice.reducer,
    [transportationReportApi.reducerPath]: transportationReportApi.reducer,
    [freightForwarderInfoApi.reducerPath]: freightForwarderInfoApi.reducer,
    [asnMatchingApi.reducerPath]: asnMatchingApi.reducer,
    [agreementApi.reducerPath]: agreementApi.reducer,
    [mfhApi.reducerPath]: mfhApi.reducer,
    [uiSlice.reducerPath]: uiSlice.reducer,
    [adminUiSlice.reducerPath]: adminUiSlice.reducer,
})

export const createStore = () => configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(transportOrderHubApi.middleware)
            .concat(notificationSettingsApi.middleware)
            .concat(transportationReportApi.middleware)
            .concat(freightForwarderInfoApi.middleware)
            .concat(asnMatchingApi.middleware)
            .concat(agreementApi.middleware)
            .concat(mfhApi.middleware),
})

export const store = createStore()
setupListeners(store.dispatch)

export type State = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<State> = useSelector
